// Analytics dimension for a count: categorical by design, the raw number is never sent.
// '0' stays its own bucket — the zero-result rate is read straight off it.
// The tail above five is banded because the building-wide read never caps: a busy hub's ~1.800
// rows and a small building's seven have to be told apart to watch that payload weight.
export function countBucket(count: number): string {
  if (count === 0) return '0';
  if (count <= 5) return '1-5';
  if (count <= 25) return '6-25';
  if (count <= 100) return '26-100';
  if (count <= 500) return '101-500';
  return '501+';
}
